export default __webpack_public_path__ + "static/media/typecar.5f9670ed.svg";